/**
 * Strips event handlers that are already consumed by react-aria's useButton/usePress.
 *
 * react-aria v3.42+ accepts `onClick` and handles it internally via usePress.
 * If we also spread the original props (including `onClick`) onto the DOM element,
 * mergeProps chains both handlers, causing `onClick` to fire twice per click.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stripHandledEvents(props: any) {
  const { onClick: _, ...rest } = props;
  return rest;
}
